module.exports = __webpack_public_path__ + "img/esr_botellas.dcc437a2.jpg";